import { forwardRef } from 'react';

import MuiFormControl from '@mui/material/FormControl';
const FormControl = forwardRef((props, ref) => {
  return <MuiFormControl ref={ref} {...props} />;
});
FormControl.displayName = 'FormControl';
export default FormControl;
